import {
  ajax,
  authenticationError,
  cors,
  csrf,
  requestBody,
  responseBody,
} from './middlewares';

export const defaultBeforeRequest = [ajax, cors, csrf, requestBody];

export const defaultAfterResponse = [responseBody, authenticationError];
